import React from "react";
import { RiArrowRightCircleLine } from "react-icons/ri";
import { Link } from "react-scroll";
const Home = () => {
  return (
    <div name="home" className="w-full h-screen bg-[#0a193f]">
      <div className="max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full">
        <p className="text-pink-600">Hi, my name is</p>
        <h1 className="text-4xl sm:text-7xl font-bold text-[#ccd6f6]">
          Kanchaporn Chiangthong
        </h1>
        <h2 className="text-4xl sm:text-7xl font-bold text-[#ccd6f6]">
          I'm a Frontend Developer
        </h2>
        <p className=" text-[#ccd6f6] py-4 max-w-[700px]">
          I'm self-taught frontend developer in building responsive website
        </p>
        <div>
          <Link to="work" smooth={true} duration={500}>
            <button className="text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600">
              View project
              <span className="group-hover:rotate-90 duration-300">
                <RiArrowRightCircleLine size={20} className="ml-3 " />
              </span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
